import {Badge, Button, Col, Modal, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Input from "../../../../common/Input";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import {toast} from "react-toastify";
import Dropdown from "../../../../primer/Dropdown";
import axios from "axios";
import {useSelector} from "react-redux";
import {MdDelete, MdOutlineWarehouse} from "react-icons/md";
import {TbDeviceMobilePlus} from "react-icons/tb";
import useMediaQuery from "../../../../../hooks/useMediaQuery";

const InsertPosModal = ({show, setShow, fetchReport}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const apiLoginURL = process.env.REACT_APP_LOGIN_URL;
    const [newSerial, setNewSerial] = useState("");
    const [loader, setLoader] = useState(false);
    const [newSerialsArray, setNewSerialsArray] = useState([]);
    const [subscriptionNames, setSubscriptionNames] = useState([]);
    const [consoleMSG, setConsoleMSG] = useState([]);
    const isMobileScreen = useMediaQuery("(max-width: 768px)");

    useEffect(() => {
        if(show) {
            setNewSerialsArray([]);
            setConsoleMSG([]);
            setNewSerial("");
            getSubscriptionNames();
            document.getElementById("newSerial").focus();
        }
    }, [show]);

    const getSubscriptionNames = () => {
        axios.get(process.env.REACT_APP_API_URL2 + `/settings/get-subscription-names`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
                user: JSON.parse(localStorage.getItem("user"))._id,
                showOnlyPos: "true"
            }
        }).then((res) => {
            if (res.data.status === "401") {
                localStorage.clear();
                window.location.replace(`${apiLoginURL}?redirect=ERP&error=You are not Authorized!`);
            } else if (res.data.status === "200") {
                let finalData = [];
                if(res.data.data && res.data.data?.length > 0) {
                    res.data.data.forEach((sub) => {
                        finalData.push({
                            label: sub.name,
                            value: sub.id,
                        })
                    })
                }
                setSubscriptionNames(finalData);
            }
        }).catch((err) => {
            console.log(err);
        })
    }


    const importSerials = async () => {
        setConsoleMSG([]);
        if(newSerialsArray?.length === 0) return toast.error("Παρακαλώ εισάγετε σειριακούς για καταχώρηση.");
        if(newSerialsArray?.some((item) => isEmpty(item?.serialNumber) || isEmpty(item?.subscription) || isEmpty(item?.warehousePosition))) return toast.error("Παρακαλώ ελέγξτε ότι όλες οι εγγραφές έχουν σειριακό αριθμό, συσκευή και θέση αποθήκης.");
        setLoader(true);
        const requestData = {company: company.id, data: newSerialsArray};
        axios.post(process.env.REACT_APP_API_URL2 + `/client/insert-primer-pos`, requestData, {
            headers: { "Content-Type": "application/json" }
        }).then((res) => {
            setLoader(false);
            if (res.data.status === "401") {
                localStorage.clear();
                window.location.replace(`${apiLoginURL}?redirect=ERP&error=You are not Authorized!`);
            } else if (res.data.status === "200") {
                toast.success(res.data.message);
                setNewSerialsArray([]);
                setConsoleMSG(consoleMSG => [...consoleMSG].concat(res.data.logs));
                fetchReport();
            }
        }).catch((err) => {
            setLoader(false);
            console.log(err);
        })

    }

    const insertNewSerial = () => {
        const serialNumber = newSerial.trim().replace(/ /g, "");
        if(isEmpty(serialNumber)) return toast.error("Ο Σειριακός Αριθμός είναι κενός.");
        const findSame = newSerialsArray.some((item) => item?.serialNumber === serialNumber);
        if (findSame) {
            setNewSerial("");
            return toast.error("Ο Σειριακός Αριθμός υπάρχει ήδη στην λίστα.");
        }
        let newSerials = [...newSerialsArray];
        let device = null;
        if(serialNumber.startsWith("V3")) {
            device = subscriptionNames.find((el) => el.label === "SUNMI V2S")?.value;
        } else if(serialNumber.startsWith("VC")) {
            device = subscriptionNames.find((el) => el.label === "SUNMI V3 MIX")?.value;
        } else if(serialNumber.startsWith("VA")) {
            device = subscriptionNames.find((el) => el.label === "SUNMI V3")?.value;
        }
        newSerials.push({serialNumber: serialNumber, subscription: device});
        setNewSerialsArray(newSerials);
        setNewSerial("");
        toast.success("Επιτυχής Εισαγωγή Συσκευής!");
        setTimeout(() => {
            document.getElementById("insertTable").scrollTop = document.getElementById("insertTable").scrollHeight;
        }, 150)
    }




    return (
        <Modal backdrop={"static"} className="themeModalMedium" show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Εισαγωγή Συσκευών POS</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span style={{fontSize: "13px"}} className={"text-muted"}><i>
                    Εισάγετε σειριακό αριθμό για εισαγωγή και στην συνέχεια πατήστε το κουμπί 'Εισαγωγή'. Ύστερα επιλέξτε τύπο συσκευής και θέση αποθήκης για κάθε σειριακό που εισάγατε. Με το αντίστοιχο κουμπί στις ενέργειες μπορείτε να εφαρμόσετε σε όλες τις εγγραφές την ίδια συσκευή ή την ίδια θέση αντίστοιχα.
                </i></span>
                 <br />
                <span style={{fontSize: "13px", color: "red"}}>
                ΠΡΟΣΟΧΗ! Την παρούσα στιγμή όταν ο σειριακός αριθμός ξεκινάει με "V3..." εισάγεται αυτόματα ως SUNMI V2S και όταν ξεκινάει με "VC..." εισάγεται αυτόματα ως SUNMI V3 MIX. Εαν κάτι τέτοιο δεν ισχύει παρακαλώ επικοινωνήστε με τον Developer!
                </span>
                <hr />
                <Row className={"align-items-center"}>
                    <Col md={8} className={"align-items-center"}>
                        <Input
                            label={"Νέος Σειριακός Αριθμός"}
                            name={"newSerial"}
                            id={"newSerial"}
                            charLimit={50}
                            placeholder={"Εισάγετε Σειριακό Αριθμό"}
                            type={"text"}
                            required={true}
                            value={newSerial}
                            onKeyDown={(e) => {
                                if(e.key === "Enter") {
                                    insertNewSerial();
                                }
                            }}
                            onChange={(e) => {
                                setNewSerial(e.target.value)}}
                        />
                    </Col>
                    <Col md={3} className={"align-self-end"}>
                        <Button
                            size={"lg"}
                            className={"ml-2 mt-4"}
                            style={{padding: "0.8rem 3rem"}}
                            disabled={isEmpty(newSerial)}
                            variant="primary"
                            onClick={() => insertNewSerial()}>
                            Εισαγωγή
                        </Button>
                    </Col>
                </Row>
                <div id={"insertTable"} style={{maxHeight: isMobileScreen ? "50vh" : "65vh", overflowY: 'auto', overflowX: isMobileScreen? 'auto' : 'hidden'}}>
                <Row className={"mt-3"}>
                    <div className="table-responsive">
                    <table className={"simpleClassicTable"} style={{width: "100%", tableLayout: "auto", wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal"}}>
                        <colgroup>
                            <col span={1} style={{width: "5%"}}></col>
                            <col span={1} style={{width: "27%"}}></col>
                            <col span={1} style={{width: "27%"}}></col>
                            <col span={1} style={{width: "15%"}}></col>
                            <col span={1} style={{width: "15%"}}></col>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>Αρ.</th>
                            <th>Σειριακός Αριθμός</th>
                            <th>Συσκευή</th>
                            <th>Θέση Αποθήκης</th>
                            <th>Ενέργειες</th>
                        </tr>
                        </thead>
                        <tbody>
                        {newSerialsArray?.map((row, idx) => (
                            <tr key={`insertTable-${idx}`}>
                                <td style={{border: "1px solid gray"}}>{String(idx + 1)}</td>
                                <td style={{border: "1px solid gray"}}>{row?.serialNumber}</td>
                                <td style={{border: "1px solid gray"}}>
                                    <Dropdown
                                    required={true}
                                    className={"mb-0"}
                                    defaultValue={subscriptionNames.find((el) => el.value === row?.subscription)}
                                    key={Math.random()}
                                    options={subscriptionNames}
                                    onChange={(e) => setNewSerialsArray(prevItems => prevItems.map((item, index) => index === idx ? { ...item, subscription: e.value } : item))}
                                    />
                                </td>
                                <td style={{border: "1px solid gray"}}>
                                    <Input
                                        unlabbled={true}
                                        name={"warehousePosition"}
                                        placeholder={"Εισάγετε Θέση Αποθήκης"}
                                        className={"align-items-center"}
                                        type={"text"}
                                        value={row?.warehousePosition}
                                        onChange={(e) => setNewSerialsArray(prevItems => prevItems.map((item, index) => index === idx ? { ...item, warehousePosition: e.target.value } : item))}
                                    />
                                </td>
                                <td style={{border: "1px solid gray"}}>
                                    <Badge
                                        bg={"primary"}
                                        className={"mr-2"}
                                        style={{cursor: "pointer"}}
                                        onClick={(e) => setNewSerialsArray(prevItems => prevItems.map(item => ({ ...item, subscription: isEmpty(item.subscription) ? row?.subscription : item.subscription })))}>
                                        <TbDeviceMobilePlus size={17} />
                                    </Badge>
                                    <Badge
                                        bg={"primary"}
                                        className={"mr-2"}
                                        style={{cursor: "pointer"}}
                                        onClick={(e) => setNewSerialsArray(prevItems => prevItems.map(item => ({ ...item, warehousePosition: isEmpty(item?.warehousePosition) ? row?.warehousePosition : item.warehousePosition })))}>
                                        <MdOutlineWarehouse size={17} />
                                    </Badge>
                                    <Badge bg={"danger"} style={{cursor: "pointer"}} onClick={() => {
                                        setNewSerialsArray(newSerialsArray.filter((item) => item?.serialNumber !== row?.serialNumber));
                                        toast.success("Επιτυχής Διαγραφή Συσκευής!");
                                    }}><MdDelete size={17} /></Badge>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>
                </Row>
                </div>
                {consoleMSG.length > 0 && (
                    <React.Fragment>
                        <hr />
                        <div className="row">
                            <div className="mb-2 col-12">
                                <p>Αρχείο καταγραφής εισαγωγής σειριακών:</p>
                                <div className="bg-light w-100 border p-3">
                                    {consoleMSG.map((e, i) => {
                                        return <p key={i}>{e}</p>;
                                    })}
                                </div>
                            </div>
                        </div>
                        <hr />
                    </React.Fragment>
                )}
            </Modal.Body>
            <Modal.Footer className="w-100 d-flex justify-content-between align-items-start flex-wrap gap-3">
                <div style={{ flex: "1 1 auto", minWidth: "250px" }}>
                    <strong>Σύνοψη Συσκευών προς Εισαγωγή ανά Τύπο:</strong>
                    <table className="table table-sm table-bordered mt-2 mb-0 text-center align-middle" style={{ fontSize: "0.9rem" }}>
                        <thead>
                        <tr>
                            <th>Τύπος Συσκευής</th>
                            <th>Πλήθος</th>
                        </tr>
                        </thead>
                        <tbody>
                        {Object.entries(newSerialsArray.reduce((acc, curr) => {
                            if (curr.subscription) {
                                acc[curr.subscription] = (acc[curr.subscription] || 0) + 1;
                            }
                            return acc;
                        }, {})).map(([subscriptionId, count]) => {
                            const sub = subscriptionNames.find(s => s.value === subscriptionId);
                            const name = sub ? sub.label : "Άγνωστο";
                            return (
                                <tr key={subscriptionId}>
                                    <td>{name}</td>
                                    <td>{count}</td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
                <div className="align-self-end">
                    <Button disabled={loader} variant="primary" onClick={() => importSerials()}>
                        Εισαγωγή Συσκευών{" "}
                        {loader && (
                            <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                        )}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default InsertPosModal;